import { ListsRetrievalFilter } from "@planzone/dto";

function areListsRetrievalFilters(
  firstFilter: ListsRetrievalFilter,
  secondFilter: ListsRetrievalFilter,
): boolean {
  return firstFilter.limit === secondFilter.limit;
}

export { areListsRetrievalFilters };
